import React from 'react';
import './contact.css';
import Footer from '../../Home/Home_modules/Footerr/footer';
//import emailjs from 'emailjs-com';

function Contact(){


   // function sendEmail(e) {
    //    e.preventDefault();
    
        //emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 
      //  user_S7zssFw1SRLDLro5XIozB)
          //.then((result) => {
            //  console.log(result.text);
         // }, (error) => {
      //        console.log(error.text);
    //      });
   //   }

    return(
        <>
        <div className="main">
            <div className="contact-title">
                <h1>Contact</h1>
            </div>
            <div className="contact-content">
                <div className="contact-location">
                <iframe 
                className="contact-map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.46980706929!2d80.26932791534361!3d13.069384466259972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52661ca3e23e5f%3A0x6de474e685aead0f!2sMount%20Road%2C%20Chennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1639299970703!5m2!1sen!2sin" 
                width="578" 
                height="530"
                allowfullscreen="" 
                loading="lazy">
                </iframe>
                </div>
                <div className="contact-info">
                    <div className="contact-details">
                        <div className="contact-no-email">
                            <h2>Reach out to us</h2>
                            <p>Talk to the CEO at <b>+15714120310</b><br/> or WhatsApp us at <b>+15714120310</b></p>
                        </div>
                        <div className="contact-no-email">
                            <h2>Email us</h2>
                            <p>Write to us at <br/><b>support@diginoor.io</b></p>
                        </div>
                        <div></div>
                    </div>
                    <div className="contact-form">
                        <h2>Let's get in touch</h2>
                        <p>Fill in your details and we'll set up a meeting</p>
                        <form>
                        <input type="hidden" name="contact_number" />
                            <input className="contact-form-fld" name="user_name"  type="text" placeholder="Name" />
                            <input className="contact-form-fld" type="email"  name="user_email" placeholder="Email" />
                            <textarea className="contact-form-txtar" name="message" placeholder="Message"></textarea>
                            <button className="contact-form-btn">SUBMIT</button>
                        </form>
                    </div>
                </div>
            </div>
            
        </div>
        <Footer/>
        </>
    )
}

export default Contact;